export default {
  'security.securityQuestions': 'Security Questions',
  'security.HeaderInfoline1':
    'Please complete all security questions and answers to continue. These questions will be used to validate your identity and provide an extra layer of protection.',
  'security.HeaderInfoline2': 'All answers must be unique',
  'security.criteriaHeader': 'Answer Criteria',
  'security.HeaderInfoline3': 'Answers are not case-sensitive and must be unique',
  'security.HeaderInfoline4': 'Special characters are allowed !@#$%^&*.()-?;:,~=+/',
  'security.securityContactInformation': 'Security Contact Information',
  'security.securityContactText':
    'The default contact details below will be our delivery point to verify your identity or send you important information regarding your account security.',
  'security.contactDetail': 'Contact Detail',
  'security.extendedSecurityWarning':
    'For extended security, we recommend using a phone number for SMS Delivery.',
  'security.extendedVoiceSecurityWarning':
    'For extended security, we recommend using a phone number for Voice Delivery.',
  'security.addMobileNumber': 'Add Mobile Number',
  'security.addVoiceNumber': 'Add Voice Number',
  'security.createNewPassword': 'Create New Password',
  'security.contact.email.notFound': 'Email not found',
  'security.contact.email.include': 'Include email as a contact point',
  'security.contact.sms.verified': 'SMS Number Verified',
  'security.contact.sms.enterCode': 'Enter Code',
  'security.contact.sms.enterCodeText':
    'Please enter and submit code sent to this mobile phone number to verify SMS.',
  'security.contact.sms.sendingCode': 'Sending Code…',
  'security.contact.sms.resendCode': 'Re-send Code',
  'security.contact.sms.verifyError': 'Please verify your number',
  'security.contact.makeDefaultError': 'Please make one of the contact options as default',
  'security.questions.question1': 'Security Question 1',
  'security.questions.question2': 'Security Question 2',
  'security.questions.question3': 'Security Question 3',
  'security.questions.uniqueAnswers': 'All answers must be unique'
};
